// extracted by mini-css-extract-plugin
export default {"textarea":"TheTextarea_textarea_updyN"};